import { goesPathsA } from "./goes-paths-a";
import { goesPathsB } from "./goes-paths-b";

export const goesPaths = (
  <>
    {goesPathsA}
    {goesPathsB}
  </>
);
